module.exports = __webpack_public_path__ + "static/media/Chapter10.dd489165.pdf";